import UseButton from '@/components/commonComps/Use/UseButton';
import styled from '@emotion/styled';

export const Container = styled.div`
height: 100vh;
position: relative;
`
export const UseButtonStyle = styled(UseButton)`
  position: absolute !important;
  background-color: #f0f0f0;
  width: 1rem;
  height: 1rem;
  bottom: .1rem;
  right: .1rem;
  z-index: 1;
`